<template>
  <div>
    <header class="navigation" style="overflow: hidden;">
      <div class="navigation-wrapper">
        <nav class="navigation-split-left nav">
          <ul>
            <router-link class="text-dark" to="/">
              <img src="/public/images/logo-wide.svg" class="logo" />
            </router-link>
            <li>
              <router-link to="/">Coop</router-link>
            </li>
            <li>
              <router-link to="/market">Market</router-link>
            </li>
            <li>
              <router-link to="/front/aide">Aide</router-link>
            </li>
            <li>
              <router-link to="/faq">FAQ</router-link>
            </li>
            <li>
              <router-link to="/tutoriels">Tutoriels</router-link>
            </li>
          </ul>
        </nav>
        <nav class="navigation-split-right nav">
          <ul class="justify-content-end">
            <li>
              <router-link to="/auth/sign-up-collectivite">Créer une collectivité</router-link>
            </li>
          
            <li>
              <router-link to="/auth/sign-in">
                Connexion <img src="/public/icons/icon-go.svg" class="nav-icon" />
              </router-link>
            </li>
          </ul>
        </nav>

        <div class="navigation-main">
          &nbsp;
        </div>
      </div>
    </header>

    <main>
      <router-view />
    </main>

    <footer>
      <p>&copy; 2026 Coop Finance. All rights reserved.</p>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PublicLayout'
})
</script>

<style scoped>
/* Dark Mode Styles */
:root[data-theme="dark"] footer {
  background-color: rgba(20, 20, 20, 1);
  color: #e0e0e0;
  padding: 1rem;
  text-align: center;
}

:root[data-theme="dark"] footer p {
  color: #e0e0e0;
}
</style>

